<template>
  <div>
    <el-form-item :label="label" prop="fields" :label-width="formLabelWidth">
        <el-button type="primary" size="small" @click="add" :loading="loading" icon="el-icon-plus">添加</el-button>
        <el-table class="custom mt10" :data="fields" border stripe v-if="fields">
          <el-table-column :label="v.label" :width="v.width" v-for="(v, i) in column" :key="i">
            <template slot-scope="scope">
              <el-input v-model="scope.row[v.value]" v-if="v.type == 'input'"></el-input>
              <el-select v-model="scope.row[v.value]" v-else-if="v.type == 'select'">
                <el-option :value="vv.value" :label="vv.text" :key="vv.value" v-for="vv in v.option"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <a @click="del(scope.$index)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
  </div>
</template>

<script>
import { deepClone } from '@/utils/base.js';
export default {
  data() {
    return {
      loading: false,
      formLabelWidth: '120px',
      option:[
        {text:'=', value:'='},
        {text:'<>', value:'<>'},
        {text:'<', value:'<'},
        {text:'<=', value:'<='},
        {text:'>', value:'>'},
        {text:'>=', value:'>='},
        {text:'in', value:'in'},
        {text:'notin', value:'notin'},
        {text:'sum', value:'sum'},
      ],
    }
  },
  props: ['label', 'column', 'fields'],
  created() {
    this.column.forEach(v => {
      if (v.type == 'select') v.option = this.option;
    });
  },
  methods: {
    add(){
      let len = this.fields.length;
      if (len){
        this.fields.push(deepClone(this.fields[len-1]));
      }else{
        let obj = {};
        this.column.forEach(v => {
          obj[v.value] = '';
        });
        this.fields.push(obj);
      }
    },
    del(index){
      this.fields.splice(index, 1);
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/input/field.vue